<app-main-store-inactive-variants-with-stock-list></app-main-store-inactive-variants-with-stock-list>
